import { render, staticRenderFns } from "./TravelTwo.vue?vue&type=template&id=f2e080d2"
import script from "./TravelTwo.vue?vue&type=script&lang=js"
export * from "./TravelTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports